<template>
  <div>
    <div class="outer">
      <div class="container">
        <div class="title" style="display:none;"></div>
        <div class="section">
          <input type="text" v-model="name" placeholder="用户名">
          <input type="password" v-model="password" placeholder="密码" @keydown.enter="load">
          <button @click="load"><i v-show="loading" style="font-size:22px" class="el-icon-loading"></i> 登录</button>
        </div>
      </div>
    </div>
    <div class="footer">
      <!-- 版权所有 上海市疾病预防控制中心 ©2020 浙ICP备13035740号 -->
      版权所有 博库科技 &copy;2021 <a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备18004034号-9</a>
    </div>
  </div>
</template>


<script>
import { hex_md5 } from '@/api/md5.js';
import axios from "axios";
export default {
  data() {
    return {
      name: '',
      password: '',
      loading: false,
    }
  },
  methods: {
    load() {
      if (this.loading) {
        return
      } else {
        this.loading = true
        axios({
          url: '/api/login',
          method: "post",
          data: { userName: this.name, passWord: hex_md5(this.password) }
        }).then(res => {
          // console.log(res)
          if (res.data.code == 8001) {
            sessionStorage.setItem('islog', 1)
            localStorage.setItem('sname',this.name)
            this.loading = false
            this.$router.push('/home')
          } else {
            this.loading = false
            this.$message.error(res.data.msg)
          }
        })
          .catch(er => {
            this.loading = false
          })
      }
    }
  }
}
</script>

<style lang="less" scoped >
.outer {
  width: 100%;
  height: 45vh;
  background: url('../assets/shjk/bglogin.png') 50% 50px no-repeat;
}
.container {
  width: 1000px;
  padding: 60px 0 0;
}
.title {
  float: left;
  width: 450px;
  height: 0;
  padding-top: 65px;
  overflow: hidden;
  background: url('../assets/shjk/logo6.png') no-repeat;
}
.section {
  float: right;
  width: 341px;
  height: 332px;
  padding: 80px 50px 0;
  background: url('../assets/shjk/entry6.png') no-repeat;
}
.section input,
.section button {
  width: 100%;
  border-radius: 2px;
  padding: 10px 0;
  margin-bottom: 15px;
  line-height: normal;
  text-indent: 10px;
  border: 1px solid #d8d8d8;
  font-size: 22px;
}
.section button {
  color: #fff;
  text-indent: 0;
  cursor: pointer;
  background: #3b75af;
}
.footer {
  width: 100%;
  position: absolute;
  bottom: 80px;
  text-align: center;
  font-size: 12px;
      a{
        color: #2440b3;
        &:hover{
          text-decoration: underline;
        }
      }
}
</style>


// WEBPACK FOOTER //
// src/pages/login.vue